import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Jumbotron } from 'reactstrap';
import axios from 'axios';
import { URI } from '../../providers/apolloClient';


function ErrorMsg(props) {
  if (props.error) {
    switch (props.error) {
    case 'NO_EMAIL':
      return 'Veuillez renseigner votre email';
    case 'NO_PASSWORD':
      return 'Veuillez renseigner votre mot de passe';
    case 'BAD_EMAIL' :
    case 'WRONG_EMAIL':
      return 'Email invalide';
    case 'BAD_PASSWORD':
    case 'WRONG_PASSWORD':
      return 'Mot de passe invalide';
    case 'WRONG_ROLE':
      return 'Vous n\'avez pas les droits requis pour accéder à l\'application';
    default:
      return 'error';
    }
  } else {
    return null;
  }
}

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: '',
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePwdChange = this.handlePwdChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleError = this.handleError.bind(this);
    this.login = this.login.bind(this);
  }

  handleLogin(e, token, roles) {
    this.props.onLogin(e, token, roles);
  }

  handlePwdChange(e) {
    this.setState({
      password: e.target.value,
    });
  }

  handleEmailChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  handleError(error) {
    this.setState({
      error: error,
    });
  }


  login(e) {
    e.preventDefault();
    axios.post(`${URI}/auth/savLoginWithPassword`, this.state)
      .then(res => {
        if (res.data.error) {
          this.handleError(res.data.error);
        } else {
          this.handleLogin(this.state.email, res.data.token, res.data.roles);
        }
      }).catch(err => {
        console.log('err', err);
      });
  }

  render() {
    return (
      <Jumbotron>
        <h3 className="display-4">
          Se connecter
        </h3>
        <hr className="my-2" />

        <Form onSubmit={this.login}>
          <FormGroup>
            <Label>Email</Label>
            <Input
              type="email"
              value={this.state.email}
              onChange={this.handleEmailChange}
            />

          </FormGroup>
          <FormGroup>
            <Label>Password</Label>
            <Input
              type="password"
              value={this.state.password}
              onChange={this.handlePwdChange}
            />
          </FormGroup>
          <Button
            type="submit"
            color="danger"
            // value={this.state.email}
          >
            Se connecter
          </Button>
          <ErrorMsg error={this.state.error} />
        </Form>
      </Jumbotron>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/login/login.js